import SecureLS from 'secure-ls'

const ls = new SecureLS({ isCompression: true })

const sessionService = {
  getValue: key => ls.get(key),
  setValue: (key, value) => ls.set(key, value),
  remove: key => ls.remove(key),
  removeAll: () => ls.removeAll(),
}
export default sessionService
